import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const ParagraphListItem = styled.p `
  margin: 0 0.5rem;
`;
export const ShowMoreInfo = styled.p `
  margin: 0 1rem;
  color: ${theme.palette.text.secondary};
`;
